import React from "react";
import {
    Autocomplete,
    TextField
} from "@mui/material";
import agent from "../../agent/agent";

class AutocompleteCategory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],

            isLoad: true
        };
    }

    componentDidMount = async () => {

        if (this.props.value) {
            await this.getCategories()
        }

    }

    getCategories = async () => {

        if (this.state.categories.length > 0) {
            return null
        }

        const categories = await agent.get(`/categories?limit=50&page=1`).then((res) => {
            return res.data.categories || []
        }).catch(() => {
            return []
        });

        this.setState({
            categories,
            isLoad: false
        })

    }

    onChange = (value) => {

        let object = {
            target: {
                name: this.props.name,
                value: value?.id || undefined
            }
        };

        this.props.onChange(object)

    }

    _getOptionLabel = (row) => {
        const options = this.state.categories || [];

        if (typeof row !== 'object') {
            const item = options.find((t) => String(t.id) === String(row));

            if (!item) {
                return ""
            }

            return item?.name
        }

        return row.name
    }
    _filterOptions = (list, params) => {
        const inputValue = params?.inputValue || "";

        return [...list].filter((t) => {

            if (!inputValue) {
                return true
            }

            const nameLowerCase = t.name.toLowerCase();
            const inputValueLowerCase = inputValue.toLowerCase();

            return Boolean(nameLowerCase.indexOf(inputValueLowerCase) > -1)

        })
    }

    render() {
        const {
            value,
            name
        } = this.props;
        const {
            categories,
            isLoad
        } = this.state;

        return (
            <>

                <Autocomplete
                    {...this.props}
                    value={value}
                    disablePortal
                    options={categories}
                    onChange={(event, value) => this.onChange(value)}
                    name={name}
                    variant="outlined"
                    fullWidth
                    disableClearable
                    autoComplete={false}
                    loading={isLoad}
                    onOpen={this.getCategories}
                    limitTags={1}

                    getOptionLabel={this._getOptionLabel}
                    filterOptions={this._filterOptions}

                    renderInput={(params) => <TextField
                        {...this.props}
                        {...params}
                        fullWidth
                    />}
                />

            </>
        );
    }
}

export default AutocompleteCategory
